module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message3-mobile-46fd8dfb.png";